import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const mlaAddressLineViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map